import KeyHostDetailScreen from "./keyHostDetailScreen";
import KeyHostListing from "./keyHostListing";

const KeyHostManagement = {
  KeyHostDetailScreen: KeyHostDetailScreen,
  KeyHostListing: KeyHostListing,
};

export default KeyHostManagement;
